import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { color } from '@nuvolo/nuux-theme/utils';
import { ReactComponent as NoAccessSvg } from '#/static/NoAccess.svg';
import React from 'react';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import styled from 'styled-components';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import TMMButton from '#/common/components/TMMButton';
import useSession from '#/common/hooks/useSession';
import { Navigate } from 'react-router-dom';

const ErrorMsg = styled(NuvoText)`
  text-align: center;
`;

const toTraneCloud = () => {
  globalThis.location.href = 'https://tranecloud.com/';
};

const NoAccess: React.FC = () => {
  const { isDesktop } = useViewport();
  const { loading, error } = useSession();

  // If access is restored (for example after refresh), leave the no-access page.
  if (!loading && !error) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <NuvoBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      backgroundColor={color('primary', 'light2')}>
      <NuvoBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        height="100vh"
        width={isDesktop ? '33vw' : '90vw'}
        gap="24px">
        <NoAccessSvg />
        <ErrorMsg type="large" className="msg">
          This user does not have access to TMM, please contact your administrator.
        </ErrorMsg>
        <TMMButton type="submit" label="Back to Trane Cloud" onClick={toTraneCloud} />
      </NuvoBox>
    </NuvoBox>
  );
};

export default React.memo(NoAccess);
